const ballotData = {
  teams: {},
  pollColumns: {
    "all-teams": {
      id: "all-teams",
      title: "Team List",
      teamIds: [],
    },
  },
  pollColumnOrder: ["all-teams"],
  detailColumns: {
    "compare-left": {
      id: "compare-left",
      title: "Compare Team",
      teamDetail: {},
    },
    "compare-right": {
      id: "compare-right",
      title: "Compare Team",
      teamDetail: {},
    },
  },
  detailColumnOrder: ["compare-left", "compare-right"],
};

export default ballotData;
